<!--
File Name          : data-collection.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container" [ngSwitch]="device.status">
    <div *ngSwitchCase="DatasnapDeviceStatus.CONNECTION_TIMEOUT" class="center-message-container">
        <div class="oops-message" role="alert">Unable To Connect</div>
        <div class="standard-card-message">Make sure your device is not on the charger and is powered on nearby.</div>
        <div class="double-button-container">
            <dx-button text="Try Again" type="default" (onClick)="retryConnection()"></dx-button>
            <dx-button text="Reselect Device" type="default" (onClick)="selectNewDevice()"></dx-button>
        </div>
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.IDLE" class="center-message-container">
        <img class="device-logo connected-flash" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device">
        <div class="message-button-keeper">
            <div class="standard-card-message" aria-live="polite">{{device.deviceState == Device_State.READY_FOR_PACKETS ? 'Device is ready' : 'Getting your device ready...'}}</div>
            <dx-button *ngIf="device.deviceState == Device_State.READY_FOR_PACKETS" text="Start Recording" type="default" (onClick)="startRecording()"></dx-button>
        </div>
        
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.RECORDING" class="center-message-container">
        <img class="device-logo recording-flash" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device recording">
        <div class="message-button-keeper">
            <div class="standard-card-message" aria-live="assertive">Device is Recording</div>
            <dx-button text="Stop Recording" type="danger" (onClick)="stopRecording()"></dx-button>
        </div>
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.OFFLOADING" class="center-message-container">
        <img class="connected-flash device-logo" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device">
        <div class="message-button-keeper">
            <div class="standard-card-message" aria-live="polite">Preparing data...</div>
            <dx-progress-bar width="100%" [value]="device.downloadStatus?.percentage ?? 0" [showStatus]="false"></dx-progress-bar>
            <div class="standard-card-message">Please Wait</div>
        </div>
        
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.ERROR_OFFLOADING" class="center-message-container">
        <img *ngIf="device.isFreeingUpStorage || device.isRebooting" class="connected-flash device-logo" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device">
        <div class="message-button-keeper" *ngIf="device.isFreeingUpStorage || device.isRebooting; else offloadingError">
            <ng-container *ngIf="device.isRebooting; else freeingUp">
                <div class="standard-card-message" aria-live="polite">Restarting DataSnap...</div>
                <div class="standard-card-message">Please wait.</div>
            </ng-container>
            <ng-template #freeingUp>
                <div class="standard-card-message" aria-live="polite">Freeing up storage...</div>
                <div class="standard-card-message">This may take a minute. Please wait.</div>
            </ng-template>
        </div>
        <ng-template #offloadingError>
            <div class="message-button-keeper">
                <div class="oops-message" role="alert">{{ device.errorMessage ?? 'Something went wrong.' }}</div>
                <dx-button style="margin:8px;" text="Reboot DataSnap" type="default" (onClick)="rebootDevice()"></dx-button>
                <dx-button style="margin:8px;" text="Try Again" type="default" (onClick)="clearRecording()"></dx-button>
            </div>
        </ng-template>
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.PARSING" class="center-message-container">
        <img class="connected-flash device-logo" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device">
        <div class="message-button-keeper">
            <div class="standard-card-message" aria-live="polite">Parsing data...</div>
            <div class="standard-card-message">Please Wait</div>
        </div>
        
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.CALCULATING" class="center-message-container">
        <img class="connected-flash device-logo" width="320" height="320" src="/assets/branding/primary_logo.svg" alt="Datasnap device">
        <div class="message-button-keeper">
            <div class="standard-card-message" aria-live="polite">Calculating results...</div>
            <div class="standard-card-message">Please Wait</div>
        </div>
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.ERROR_CALCULATING" class="center-message-container">
        <div class="message-button-keeper">
            <div class="oops-message" role="alert">Try again.</div>
            <div class="standard-card-message">Be sure these required motions happen.</div>
        </div>
        <img class="trigger-img" [src]="getTriggerImgPath()" alt="Required trigger motion">
        <dx-button style="margin:8px; min-width:192px;" text="Try Again" type="default" (onClick)="clearRecording()"></dx-button>

        
    </div>
    <div *ngSwitchCase="DatasnapDeviceStatus.DISPLAYING" class="results-container">
        <div><ng-content results></ng-content></div>
        <div class="post-recording-buttons">
            <dx-button  [disabled]="device.parsedData == null" text="Download Data" (onClick)="downloadData()" type="default"></dx-button>
            <dx-button  text="Clear and Record New" type="default" (onClick)="clearRecording()"></dx-button>
        </div>
    </div>
</div>

<dx-popup
    #fwUpdatePopup
    [visible]="showFWUpdatePopup()"
    [showTitle]="true"
    [title]="'Update Available'"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    [height]="400"
    [width]="400"
    maxHeight="100%"
    maxWidth="100%"
>
    <div class="update-message">There is a new firmware version for this Motion Datasnap. This will take around 5 minutes.</div>
    <br>
    <div class="update-message">Keep Motion Snap near this device.</div>
    <div class="update-message">Ensure Motion Snap is charged.</div>
    <div class="update-message">Do not place the sensor on the charger during the update. If you do, the update will stop and the sensor will disconnect.</div>
    <br>
    <dx-button text="Okay" type="default" (onClick)="initiateFWUpdate()"></dx-button>
</dx-popup>

<dx-popup
    #selectDevicePopup
    [visible]="showSelectDevicePopup()"
    [showTitle]="true"
    [title]="'Reconnect Device'"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    [height]="400"
    [width]="400"
    maxHeight="100%"
    maxWidth="100%"
>

    <div class="update-message">Your device lost its sensor connection. Pair again to continue. You may need to refresh your browser to enable connection.</div>
    <br>

    <dx-button text="Okay" type="default" (onClick)="reselectDevice()"></dx-button>

</dx-popup>

